import React, { useState } from 'react';
import Button from '../common/Button';

const OpenCardsInStoreButton = ({ cards, store }) => {
  const [isOpening, setIsOpening] = useState(false);

  const openCardsInStore = () => {
    if (!cards || cards.length === 0) return;

    // Extract unique store URLs from all cards
    const storeUrls = cards
      .map(card => {
        // Get the cheapest price (first in sorted array) for each card
        const cheapestPrice =
          card.cardPrices && card.cardPrices.length > 0
            ? card.cardPrices[0]
            : null;
        return cheapestPrice?.storeUrl;
      })
      .filter(url => url) // Remove null/undefined URLs
      .filter((url, index, array) => array.indexOf(url) === index); // Remove duplicates

    if (storeUrls.length === 0) {
      alert('No se encontraron enlaces de tienda para estas cartas.');
      return;
    }

    // Show confirmation for multiple tabs
    if (storeUrls.length > 1) {
      const confirmed = window.confirm(
        `¿Estás seguro de que quieres abrir ${storeUrls.length} enlaces en nuevas pestañas?`,
      );
      if (!confirmed) return;
    }

    setIsOpening(true);

    // Open URLs with small delays to improve success rate with popup blockers
    storeUrls.forEach((url, index) => {
      setTimeout(() => {
        try {
          window.open(url, '_blank', 'noopener,noreferrer');
        } catch (error) {
          console.error('Error opening URL:', url, error);
        }

        // Reset loading state after last URL
        if (index === storeUrls.length - 1) {
          setTimeout(() => setIsOpening(false), 100);
        }
      }, index * 200); // 200ms delay between each URL
    });
  };

  return (
    <Button
      className="min-w-52"
      iconClass="fas fa-external-link-alt"
      onClick={openCardsInStore}
      disabled={isOpening}>
      {isOpening ? 'Abriendo...' : 'Abrir cartas en tienda'}
    </Button>
  );
};

export default OpenCardsInStoreButton;
